import React from "react";
import { AddRackOptions } from "../../constants";
import { DateSelector } from "../selectors/DateSelector";
import { PassageNumberSelector } from "../selectors/PassageNumberSelector";
import { RunSelector } from "../selectors/RunSelector";

interface MonoclonalizationProps {
  values: AddRackOptions;
  setFieldValue: (
    field: string,
    value: any,
    shouldValidate?: boolean | undefined
  ) => void;
}

export const Monoclonalization = ({
  values,
  setFieldValue,
}: MonoclonalizationProps) => {
  return (
    <React.Fragment>
      <RunSelector values={values} setFieldValue={setFieldValue} />
      <PassageNumberSelector values={values} setFieldValue={setFieldValue} />
      <DateSelector values={values} setFieldValue={setFieldValue} />
    </React.Fragment>
  );
};
